/* eslint-disable no-param-reassign */
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface PublishSectionBaseTextModalState {
    isOpen: boolean;

    data: {
        id: number;

        body: string;

        documentId: number;

        chapterId: number;
    } | null;

    confirmed:boolean,
}

export interface PublishSectionBaseTextModalDispatchParams {
    id: number;

    body: string;

    documentId: number;

    chapterId: number;
}

const initialState: PublishSectionBaseTextModalState = {
    isOpen: false,
    data: null,
    confirmed: false,
};

export const publishSectionBaseTextModalSlice = createSlice({
    name: 'publish-section-base-text-modal',
    initialState,
    reducers: {
        open(state: PublishSectionBaseTextModalState, action: PayloadAction<PublishSectionBaseTextModalDispatchParams>) {
            state.isOpen = true;
            state.data = action.payload;
        },
        close(state: PublishSectionBaseTextModalState) {
            state.isOpen = false;
            state.data = null;
            state.confirmed = false;
        },
        confirm(state: PublishSectionBaseTextModalState) {
            state.isOpen = false;
            state.data = null;
            state.confirmed = true;
        },
    },
});
